export const GET_ACTS = 'GET_ACTS';
export const GET_ACTS_SUCCESS = 'GET_ACTS_SUCCESS';
export const GET_ACTS_FAIL = 'GET_ACTS_FAIL';

export const SIGN_ACTS = 'SIGN_ACTS';
export const SIGN_ACTS_SUCCESS = 'SIGN_ACTS_SUCCESS';
export const SIGN_ACTS_FAIL = 'SIGN_ACTS_FAIL';
